import React from 'react';

import { Patients } from '../containers/Database/Patients';

const DatabasePage = () => (
    <Patients />
);

export default DatabasePage;